import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

const OPTIONS = [
  {
    value: 'track-daily-expenses',
    translationKey: 'pages.onboarding.mainGoal.options.track-daily-expenses',
  },
  {
    value: 'organize-categories',
    translationKey: 'pages.onboarding.mainGoal.options.organize-categories',
  },
  {
    value: 'keep-digital-copies',
    translationKey: 'pages.onboarding.mainGoal.options.keep-digital-copies',
  },
  {
    value: 'save-money-budget',
    translationKey: 'pages.onboarding.mainGoal.options.save-money-budget',
  },
]

export default function MainGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.mainGoal.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
